<template>
    <el-dialog
      custom-class="real-dialog"
      :visible="dialogVisible"
      width="80%"
      center
      append-to-body
      @close="handleCloseDialog"
    >
      <div style="margin-bottom: 20px;">
        <el-radio-group v-model="activeType" @input="handleClick">
          <el-radio-button label="first">场内查询</el-radio-button>
          <el-radio-button label="second">出场查询</el-radio-button>
          <el-radio-button label="third">订单查询</el-radio-button>
        </el-radio-group>
      </div>
      <!--
      <el-tabs v-model="activeType" type="card" @tab-click="handleClick">
        <el-tab-pane label="场内查询" name="first"> </el-tab-pane>
        <el-tab-pane label="出场查询" name="second">
        </el-tab-pane>
        <el-tab-pane label="订单查询" name="third">
        </el-tab-pane>
      </el-tabs>-->
      <query-order-table ref="orderTable" v-if="activeType === 'third'"></query-order-table>
      <query-site ref="queryTable" :type="activeType" v-else/>
    </el-dialog>
</template>

<script>
import querySite from "./querySiteTable";
// import queryLeave from "./queryLeaveTable";
// import queryCharge from "./queryChargeTable";
import showdialog from '@/minxs/showdialog'
import queryOrderTable from "./queryOrderTable";
import { dialogTablePubSub } from "@/service/pubsub/index";
import { getTenantId } from "@/utils/service";

export default {
  components: {
    querySite,
    queryOrderTable,
    // queryLeave,
    // queryCharge,
  },
  props: {
    activeName: {
      type: String,
      default: "first",
    },
  },
  mixins:[showdialog],
  data() {
    return {
      activeType: this.activeName,
      TenantId: null,
    };
  },
  computed: {
    showArrearsDialog: function () {
      return this.$store.state.layout.showArrearsDialog
    },
  },
  watch: {
    activeName(v) {
      this.activeType = v;
    },
    dialogVisible(v) {
      // console.log(v);
      if (v) {
        console.log(this.activeType)
        this.$nextTick(() => {
          if (this.activeType === 'third'){
            this.$refs.orderTable.plateNumber = '';
            // this.$store.dispatch("SetPubOutGateId", '');
            this.$refs.orderTable.isLeft = this.showArrearsDialog ? undefined : 2;
            this.$refs.orderTable.PayType = this.showArrearsDialog ? 'notPay' : undefined;
            this.$refs.orderTable.server();
          } else if (this.activeType === 'first'){
            this.$refs.queryTable.searchStr = '';
            // this.$refs.orderTable.isLeft = 2;
            this.$refs.queryTable.server();
          } else{
            this.$refs.queryTable.searchStr = '';
            this.$refs.queryTable.server();
          }
        })
      }
    }
  },
  mounted() {
    this.TenantId = parseInt(getTenantId());
    dialogTablePubSub.subscribe(this.handleClose);
  },
  methods: {
    handleClick(key) {
      this.activeType = key;
      // console.log(this.activeType);
      this.$nextTick(() => {
        if (this.activeType === 'third'){
          this.$refs.orderTable.plateNumber = '';
          this.$store.dispatch("SetPubOutGateId", '');
          this.$refs.orderTable.isLeft = 2;
          this.$refs.orderTable.server();
        } else {
          this.$refs.queryTable.searchStr = '';
        }
      })
    },
    handleCloseDialog() {
      this.$store.dispatch("SetShowArrearsDialog", false);
      this.handleClose();
    }
  },
};
</script>

<style>
.search-table-top {
  text-align: center;
  line-height: 2;
  margin-bottom: 20px;
}
</style>
